// src/schemas/registration.schema.ts
import { z } from 'zod';


export const registrationSchema = z
  .object({
    // Step 1
    businessName: z.string().min(2, 'Business name is required'),
    ownerName: z.string().min(2, 'Owner name is required'),
    email: z.email('Invalid email address'),
    password: z
      .string()
      .min(6, 'Password must be at least 6 characters')
      .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/, 'Must contain uppercase, lowercase, and number'),
    confirmPassword: z.string(),

    // Step 2
    phone: z.string().min(10, 'Valid phone number required'),
    businessPhone: z.string().min(10, 'Valid business phone required'),
    businessAddress: z.string().min(5, 'Business address is required'),
    businessType: z.string().min(1, 'Please select a business type'),
    cuisineTypes: z
      .array(z.string())
      .min(1, 'Please select at least one cuisine type'),

    description: z.string().optional(),



    hasWhatsAppBusiness: z.boolean().default(false),
    whatsappBusinessId: z.string().optional(),
    whatsappPhoneNumber: z
      .string()
      .optional()

      .refine(
        (val) => !val || val.length >= 10,
        { message: 'Valid WhatsApp phone required' }
      ),
    whatsappAccessToken: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.password !== data.confirmPassword) {
      ctx.addIssue({
        code: "custom",
        message: 'Passwords do not match',
        path: ['confirmPassword'],
      });
    }

    if (data.hasWhatsAppBusiness) {
      if (!data.whatsappBusinessId || !data.whatsappAccessToken) {
        ctx.addIssue({
          code: "custom",
          message: 'WhatsApp Business ID is required when WhatsApp is enabled',
          path: ['whatsappBusinessId'],
        });
        ctx.addIssue({
          code: "custom",
          message: 'WhatsApp Business Token is required when WhatsApp is enabled',
          path: ['whatsappAccessToken'],
        });
      }
    }
  });

// inferred type used across the app
export type VendorRegistrationPayload = z.infer<typeof registrationSchema>;
